const compareWithNullable = (a: string, b: string | null | undefined) => {
  return a?.toLowerCase() === (b || '').toLowerCase();
};

export default compareWithNullable;